import { render } from "./terms-condition-area.vue?vue&type=template&id=55a05ca2&scoped=true"
import script from "./terms-condition-area.vue?vue&type=script&lang=js"
export * from "./terms-condition-area.vue?vue&type=script&lang=js"

import "./terms-condition-area.vue?vue&type=style&index=0&id=55a05ca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a05ca2"]])

export default __exports__